<template>
  <span
    v-if="isCountDownVisible"
    v-show="!slide.stopSubmission"
    ref="timeToAnswer"
  />
</template>

<script>
import Config from '@/config'
import Util from '@/util'
import * as Sentry from '@sentry/vue'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      timeToAnswer: 0,
      requestFrame: null,
    }
  },

  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
    isCountDownVisible() {
      return this.slide.hasTimeLimit &&
      !this.$store.state.presentation.audiencePacing &&
      this.$store.state.presentation.presenting &&
      this.slide.type !== 'ideas'
    },
  },

  watch: {
    'slide.stopSubmission': function watchStopSubmission(stop) {
      this.cancelAnimationFrame()
      if (!stop) {
        this.startCountDownTimeToAnswer()
      }
    },
    'slide.stopSubmissionTime': function watchStopSubmissionTime() {
      this.cancelAnimationFrame()
      this.startCountDownTimeToAnswer()
    },
  },

  mounted() {
    if (!this.$store.state.offsetTime) {
      this.$http.get(Config.api.getTimestamp).then((res) => {
        this.$store.state.offsetTime = Util.getTimeStamp() - res.body.timeStamp
        if (!this.slide.stopSubmission) {
          this.startCountDownTimeToAnswer()
        }
      }).catch((error) => {
        Sentry.captureException(error)
        this.$store.state.offsetTime = 0
        if (!this.slide.stopSubmission) {
          this.startCountDownTimeToAnswer()
        }
      })
    } else if (!this.slide.stopSubmission) {
      this.startCountDownTimeToAnswer()
    }
  },

  destroyed() {
    this.cancelAnimationFrame()
  },

  methods: {
    startCountDownTimeToAnswer() {
      const self = this
      const endTime = this.slide.stopSubmissionTime

      if (!endTime) return
      this.timeToAnswer = parseInt((endTime - Util.getcurTimeStamp()) / 1000, 10)

      let contextTimeToAnswer = this.$refs.timeToAnswer
      if (contextTimeToAnswer) {
        contextTimeToAnswer.textContent = `(${Util.timeToString(this.timeToAnswer)})`
      }

      let secondTime = 0

      function step(timestamp) {
        const timeRun = parseInt(timestamp / 1000, 10)
        if (secondTime !== timeRun) {
          secondTime = timeRun

          self.timeToAnswer = parseInt((endTime - Util.getcurTimeStamp()) / 1000, 10)
          contextTimeToAnswer = self.$refs.timeToAnswer

          if (contextTimeToAnswer) {
            contextTimeToAnswer.textContent = `(${Util.timeToString(self.timeToAnswer)})`
          }
        }

        if (self.timeToAnswer > 0) {
          self.requestFrame = window.requestAnimationFrame(step)
        } else {
          self.cancelAnimationFrame()
        }
      }

      self.requestFrame = window.requestAnimationFrame(step)
    },

    cancelAnimationFrame() {
      if (this.requestFrame) {
        window.cancelAnimationFrame(this.requestFrame)
      }
    },
  },
}
</script>
